module.exports = __webpack_public_path__ + "static/gallery_west_street_4_thumb-4ebf518578ef32ecb158c6022582215f.jpg";